import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { IoIosArrowBack } from "react-icons/io";
import Header from "../Header.js";

const ChangePassword = ({ backLink = "/dashboard", showHeader = true, showBackLink = true, className = "" }) => {
    const [password, setPassword] = useState('');
    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [confirmNewPassword, setConfirmNewPassword] = useState(false);

    const navigate = useNavigate();

    return (
        <>
            <div className={`profile-wrapper ${className}`}>
                {showHeader && <Header />}
                {/* dashboardに戻る */}
                
                <div onClick={() => navigate(backLink)} style={{ cursor: "pointer" }} className="nav_title">
                    <IoIosArrowBack />
                    Dashboard
                </div>
                
                <label>Your current password</label>
                <div className="input_wrapper">
                    <input
                        id="current-pw"
                        type={showCurrentPassword ? "text" : "password"}
                        placeholder="Current password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span
                        onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    >
                        {showCurrentPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                </div>
                <label>Your new password</label>
                <div className="input_wrapper">
                    <input
                        id="new-pw"
                        type={showNewPassword ? "text" : "password"}
                        placeholder="New password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                        required
                    />
                    <span
                        onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                        {showNewPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                </div>
                <label>Confirm your new password</label>
                <div className="input_wrapper">
                    <input
                        id="current-pw"
                        type={confirmNewPassword ? "text" : "password"}
                        placeholder="Confirm new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span
                        onClick={() => setConfirmNewPassword(!confirmNewPassword)}
                    >
                        {confirmNewPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                </div>
                <div className="btn-wrapper">
                    <button type="reset" className="cancel">Cancel</button>
                    <button type="submit">Save</button>
                </div>
            </div>
        </>
    );

}

export default ChangePassword;